import { isProd } from "@/config/common";
import {
  ContentfulLocaleEnum,
  CountryCodeEnum,
  CountryNameEnum,
  CurrencyCodeEnum,
  DomainEnum,
  ElevateCodeEnum,
  LanguageCodeEnum,
  type Market,
  PSPEnum,
  SiteLocaleEnum,
  SiteNameEnum,
} from "./i18n-config";

export const no: Market = {
  psp: PSPEnum.WALLEY,
  flag: "🇳🇴",
  currency: CurrencyCodeEnum.NOK,
  countryCode: CountryCodeEnum.NO,
  countryName: CountryNameEnum.NO,
  languageCode: LanguageCodeEnum.NO,
  locale: `${LanguageCodeEnum.NO}-${CountryCodeEnum.NO}`,
  upperCaseLocale: `${LanguageCodeEnum.NO}-${CountryCodeEnum.NO.toUpperCase()}`,
  contentfulLocale: ContentfulLocaleEnum.NO,
  siteLocale: SiteLocaleEnum.NO,
  elevateMarket: ElevateCodeEnum.NO,
  externalStoreId: "ecom-no",
  bookingMarket: "NGNO",
  walleyStoreCodeB2B: isProd() ? 11447 : 6350,
  walleyStoreCodeB2C: isProd() ? 11446 : 6349,
  searchPathName: "/sog",
  domain: DomainEnum.NGNO,
  imageCdn: isProd()
    ? "https://cdn.nordiskagalleriet.se"
    : "https://media.stage.cdn-norce.tech/1413",
  siteName: SiteNameEnum.NO,
};
